var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"floating-button",attrs:{"bottom":"","fab":"","fixed":"","right":"","type":"submit"}},[_c('v-icon',{attrs:{"large":""}},[_vm._v("save")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }